module.exports = "/_next/static/images/c6833206b27fd25459d1faf21826a367-computer-desk-man@xs-1x.jpg.webp";